<p-confirmPopup></p-confirmPopup>
<section class="flex justify-content-center mt-4">
	<div class="card-table col-12 md:col-10 lg:col-8 pt-6">
		<custom-table [config]="customTable">
		</custom-table>		
	</div>
</section>

<section>
	<form [formGroup]="dependenciaForm" (ngSubmit)="onSubmit()">
		<p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
			[resizable]="true" [maximizable]="true"
			[breakpoints]="{'640px': '100vw'}" [style]="{width: '60vw'}">

			<ng-template pTemplate="header">
				<CustomTitle [title]="formTitle" />
			</ng-template>

			<ng-template pTemplate="content">
				<main class="grid formgrid p-fluid">
					<div class="field col-12">
						<label class="ml-3" for="descripcion">{{ 'common.descripcion' | translate }}<span style="color: red">*</span></label>
						<input pInputText formControlName="descripcion" id="descripcion" type="text" style="width: 100%" />
						<ng-container
							*ngIf="dependenciaForm.get('descripcion')?.invalid && dependenciaForm.get('descripcion')?.touched">
							<app-form-group-error-message [control]="dependenciaForm.get('descripcion')"></app-form-group-error-message>
						</ng-container>
					</div>
					<div class="field col-12">
						<label class="ml-3" for="liderDependenciaId">{{ 'common.liderDependencia' | translate }}<span style="color: red">*</span></label>
						<p-dropdown 
							formControlName="liderDependenciaId" 
							id="liderDependenciaId"
							[options]="usuarios" 
							optionLabel="nombreCompleto"
							optionValue="id"							
							[filter]="true"
							[showClear]="true"
							appendTo="body"
							styleClass="w-full">
						</p-dropdown>
						<ng-container
							*ngIf="dependenciaForm.get('liderDependenciaId')?.invalid && dependenciaForm.get('liderDependenciaId')?.touched">
							<app-form-group-error-message [control]="dependenciaForm.get('liderDependenciaId')"></app-form-group-error-message>
						</ng-container>
					</div>
				</main>
			</ng-template>

			<ng-template pTemplate="footer">
				<div class="field col-12">
					<div class="flex justify-content-between">
						<button pButton type="button" [label]="'form.button.limpiar' | translate" iconPos="right" icon="pi pi-eraser" class="tax-app-button"
							(click)="resetForm()"></button>
						<button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save" iconPos="right" class="tax-app-button"
							[disabled]="!ls.hasRole(role.ADMIN_SEC)"></button>
					</div>
				</div>
			</ng-template>
		</p-dialog>
	</form>
</section>

<app-admin-dependencias-historico></app-admin-dependencias-historico>